
import axiosInstance from '@/api'
import { logException } from '@/utils/log'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      infos: [
        { name: 'Revision ID', value: process.env.VUE_APP_GIT_HASH },
        { name: 'App Version', value: process.env.VUE_APP_VERSION },
        { name: 'Build Date', value: process.env.VUE_APP_BUILD_DATE },
      ] as { name: string; value: string }[],
      snackbar: {
        active: false,
        valueCopied: '',
      },
      remoteInfos: {
        loading: true,
        value: [] as { name: string; value: string }[],
        error: '',
      },
    }
  },
  methods: {
    async copy(value: string) {
      this.snackbar = {
        active: true,
        valueCopied: value,
      }
      await navigator.clipboard.writeText(value)
      throw new Error()
    },
  },
  computed: {
    revisionId() {
      return process.env.VUE_APP_GIT_HASH
    },
  },
  async mounted() {
    this.remoteInfos.loading = true
    try {
      const response = await axiosInstance.get('../info')
      this.remoteInfos.loading = false
      this.remoteInfos.value = [
        { name: 'Revision ID', value: response.data['build.revision'] },
        { name: 'App Version', value: response.data.version },
        { name: 'Build Date', value: response.data['build.date'] },
      ]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      logException(e)
      this.remoteInfos.loading = false
      this.remoteInfos.error = 'Erreur lors de la récupération des infos du serveur'
    }
  },
})
